import {
    JSMOverlayTemplate,
    SignupBackgroundLayout
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils";
import { ExperimentView, experiments } from "@/utils/experiment";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    CreateAWorkspaceHeading,
    CreateAWorkspaceText,
    Headings,
    SubHeading,
    WorkspacesAreWhereText
} from "../components";

const NewUserContent = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <>
            {team26VisualUpdates ? (
                <Headings
                    main={<CreateAWorkspaceText />}
                    sub={<WorkspacesAreWhereText />}
                />
            ) : (
                <>
                    <CreateAWorkspaceHeading />
                    <SubHeading>
                        <WorkspacesAreWhereText />
                    </SubHeading>
                </>
            )}
            <SiteActivation />
        </>
    );
};

export const NewUser = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <NewUserContent />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <NewUserContent />
                </SignupBackgroundLayout>
            )
        }
    />
);
